import { render, staticRenderFns } from "./HeaderUpperNavbar.vue?vue&type=template&id=24460bf1&lang=pug&"
import script from "./HeaderUpperNavbar.vue?vue&type=script&lang=js&"
export * from "./HeaderUpperNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports